"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

require("core-js/modules/es.array.reduce.js");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyChameleonDesign = exports.useChameleonContext = exports.DEFAULT_KEY = void 0;

var react_1 = __importStar(require("react"));

var core_1 = require("@bodiless/core");

var fclasses_1 = require("@bodiless/fclasses");

var lodash_1 = require("lodash");

var ChameleonContext = react_1.createContext(undefined);
exports.DEFAULT_KEY = '_default';

var getSelectableComponents = function getSelectableComponents(props) {
  var components = props.components; // @ts-ignore @TODO need to add metadata to component type

  if (components[exports.DEFAULT_KEY].title) return components;
  return lodash_1.omit(components, exports.DEFAULT_KEY);
};

var getActiveComponent = function getActiveComponent(props) {
  var component = props.componentData.component;
  var components = getSelectableComponents(props);
  return component && components[component] ? component : exports.DEFAULT_KEY;
};

var getIsOn = function getIsOn(props) {
  return getActiveComponent(props) !== exports.DEFAULT_KEY;
};
/**
 * Gets the current chameleon context value.
 *
 * @see withChameleonContext
 */


var useChameleonContext = function useChameleonContext() {
  var value = react_1.useContext(ChameleonContext);
  if (!value) throw new Error('No active chameleon context');
  return value;
};

exports.useChameleonContext = useChameleonContext;
/**
 * @private
 *
 * HOC makes the wrapped component designable using the wrapped component itself as the start
 * for every key in the design.
 *
 * @param Component
 */

var applyChameleonDesign = function applyChameleonDesign(Component) {
  var apply = function apply(design) {
    var _a;

    if (design === void 0) {
      design = {};
    }

    var Component$ = fclasses_1.asComponent(Component);
    var start = Object.keys(design).reduce(function (acc, key) {
      var _a;

      return __assign(__assign({}, acc), (_a = {}, _a[key] = Component$, _a));
    }, (_a = {}, _a[exports.DEFAULT_KEY] = Component$, _a));
    return fclasses_1.applyDesign(start)(design);
  };

  return fclasses_1.extendDesignable()(apply, 'Chameleon');
};

exports.applyChameleonDesign = applyChameleonDesign;

var withChameleonContext = function withChameleonContext(nodeKeys, defaultData) {
  return function (Component) {
    var WithChameleonContext = function WithChameleonContext(props) {
      return react_1.default.createElement(ChameleonContext.Provider, {
        value: {
          isOn: getIsOn(props),
          activeComponent: getActiveComponent(props),
          selectableComponents: getSelectableComponents(props),
          setActiveComponent: function setActiveComponent(component) {
            return props.setComponentData({
              component: component
            });
          }
        }
      }, react_1.default.createElement(Component, __assign({}, lodash_1.omit(props, 'componentData', 'components', 'setComponentData'))));
    };

    return core_1.withSidecarNodes( // We apply the design to a fragment here so as to get the keys. We can't get the actual
    // components until `applyChameleon` bc we don't yet know the start component.
    applyChameleonDesign(react_1.Fragment), core_1.withBodilessData(nodeKeys, defaultData))(WithChameleonContext);
  };
};

exports.default = withChameleonContext;